<div class="invitation-container container" fxFlexFill fxLayout="column" fxLayoutAlign="start center">
  <div class="page-container">
    <div class="invitation-expired-container container" fxLayout="column" fxLayoutAlign="start center"
         fxLayoutGap="30px" *ngIf="invitation && isExpired">
      <h1 class="mat-h1 color-accent text-small-caps text-center">{{'INVITATION_EXPIRED' | translate}}</h1>
      <p>{{'PLEASE_CONTACT' | translate}} <a class="color-help"
                           [href]="'mailto:' + invitation.inviter.email + '?subject=MTN%20Insights%20Invitation%20Expired'"
                           target="_blank">{{invitation.inviter.getDisplayName()}}</a> {{'FOR_HELP' | translate}}</p>
    </div>
    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px" *ngIf="invitation && !isExpired">
      <h1 class="mat-h1 color-primary text-small-caps text-center">{{'JOIN_INSIGHTS' | translate}}</h1>
      <div class="text-center" fxLayout="column" *ngIf="invitation && !isExpired">
        <strong>{{invitation.inviter.getDisplayName()}}</strong>
        <span class="color-muted">{{'INVITATION_MESSAGE' | translate}}</span>
        <strong>{{invitation.invitation.company.name}}</strong>
        <span class="color-muted">{{'IN_INSIGHTS' | translate}}</span>
      </div>
      <div class="other-company-alert-container constrained-width-container container"
           *ngIf="isMemberOfOtherCompany; else newUser"
           fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
        <div class="other-company-alert" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
          <fa-icon class="color-accent" icon="exclamation-triangle" size="2x"></fa-icon>
          <strong>{{OTHER_COMPANY_ALERT_TITLE}}</strong>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <mat-checkbox [formControl]="otherCompanyAcknowledgement" color="primary"></mat-checkbox>
          <div [innerHTML]="otherCompanyAlertText"></div>
        </div>
      </div>
      <ng-template #newUser>
        <div class="form-container container" fxLayout="column" fxLayoutGap="15px" [formGroup]="userForm"
             *ngIf="userForm">
          <div>
            <h3 class="mat-h3">{{'CREATE_YOUR_ACCOUNT' | translate}}</h3>
            <div fxLayout="row" fxLayoutGap="15px">
              <p>{{'AUTH0_DESCRIPTION' | translate}} <a href="https://auth0.com" target="_blank">Auth0</a>
                {{'AUTH0_LINK' | translate}}</p>
              <a href="https://auth0.com" target="_blank"><img height="40" src="assets/images/auth0-logo.png"
                                                               alt="Auth0 logo"/></a>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <mtn-text-field [form]="userForm" controlName="firstName" placeholder="First Name"></mtn-text-field>
            <mtn-text-field [form]="userForm" controlName="lastName" placeholder="Last Name"></mtn-text-field>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <mat-form-field class="default-field-width container" appearance="outline">
              <mat-label>{{'PASSWORD' | translate}}</mat-label>
              <input [type]="isPasswordShown ? 'text' : 'password'" matInput formControlName="password"/>
              <mat-error *ngIf="userForm.get('password').hasError('required')">
                <i>{{'MUST_BE_PROVIDED' | translate}}</i>
              </mat-error>
              <mat-error
                *ngIf="userForm.get('password').hasError('missingNumber') || userForm.get('password').hasError('missingUpperCase') || userForm.get('password').hasError('missingLowerCase') || userForm.get('password').hasError('missingSpecialCharacter') || userForm.get('password').hasError('maxlength') || userForm.get('password').hasError('minlength')">
                <i>{{'INVALID_PASSWORD' | translate}}</i>
              </mat-error>
              <fa-icon class="clickable show-hide-password" [icon]="isPasswordShown ? 'eye-slash' : 'eye'"
                       (click)="isPasswordShown = !isPasswordShown"></fa-icon>
            </mat-form-field>
            <mat-form-field class="default-field-width" appearance="outline">
              <mat-label>{{'CONFIRM_PASSWORD' | translate}}</mat-label>
              <input [type]="isPasswordShown ? 'text' : 'password'" matInput formControlName="confirmPassword"/>
              <mat-error *ngIf="userForm.get('confirmPassword').hasError('required')">
                <i>{{'MUST_BE_PROVIDED' | translate}}</i>
              </mat-error>
              <mat-error *ngIf="userForm.get('confirmPassword').hasError('noPasswordMatch')">
                <i>{{'PASSWORDS_DO_NOT_MATCH' | translate}}</i>
              </mat-error>
              <fa-icon class="clickable show-hide-password" [icon]="isPasswordShown ? 'eye-slash' : 'eye'"
                       (click)="isPasswordShown = !isPasswordShown"></fa-icon>
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <div class="color-muted" fxLayout="column" style="font-size: 12px; line-height: 12px;">
              <small>{{'PASSWORD_MUST_INCLUDE_AT_LEAST' | translate}}</small>
              <small style="margin-left: 20px">{{'10_characters' | translate}}</small>
              <small style="margin-left: 20px">{{'1_upper_case_letter'}}</small>
              <small style="margin-left: 20px">{{'1_lower_case_letter'}}</small>
              <small style="margin-left: 20px">{{'1_number' | translate}}</small>
              <small style="margin-left: 20px">{{'1_special_character' | translate}} (!,&#64;,#,$,%, etc)</small>
            </div>
          </div>
          <br/>
          <div fxLayout="row" fxLayoutGap="10px" style="margin-bottom:15px">
            <mat-checkbox color="primary" formControlName="authorization"></mat-checkbox>
            <div fxFlex>
              {{'ACKNOWLEDGEMENT' | translate}}
            </div>
          </div>
        </div>
      </ng-template>
      <button class="accept-button" mat-raised-button color="primary" (click)="acceptInvitation()"
              [disabled]="otherCompanyAcknowledgement?.invalid || userForm?.invalid">
        {{'ACCEPT_INVITATION' | translate}}
      </button>
    </div>
  </div>
  <mtn-spinner [on]="!invitation" [size]="SpinnerSize.LARGE"></mtn-spinner>
</div>
